import { createAction } from "@reduxjs/toolkit";
import { SET_EXPERIMENT_STATUS } from "./constants";

export const setExperimentStatus = createAction(SET_EXPERIMENT_STATUS);